import { Component } from '@angular/core';

@Component({
    selector: 'app-chart-legend',
    templateUrl: './legend.component.html',
    styleUrls: ['./legend.component.scss'],
    standalone: false,
})
export class LegendComponent {}
